module.exports = __webpack_public_path__ + "static/antd-card-tabs-db92d41acead6199e13810014a1d84c8.gif";